import React from 'react'
import {
  Label,
  Slider,
  SliderOutput,
  SliderThumb,
  SliderTrack,
  type SliderProps,
} from 'react-aria-components'

import './RangeSlider.css'

interface RangeSliderProps<T> extends SliderProps<T> {
  label?: string
  thumbLabels?: string[]
  maxValueSuffix?: string
}

export function RangeSlider<T extends number | number[]>({
  label,
  thumbLabels,
  maxValueSuffix = '',
  ...props
}: RangeSliderProps<T>) {
  return (
    <Slider {...props}>
      {label && <Label>{label}</Label>}
      <SliderOutput>
        {({ state }) =>
          state.values.map((_, i) => state.getThumbValueLabel(i)).join(' – ') +
          (state.values[state.values.length - 1] === props.maxValue ? maxValueSuffix : '')
        }
      </SliderOutput>
      <SliderTrack>
        {({ state }) =>
          state.values.map((_, i) => (
            <SliderThumb key={i} index={i} aria-label={thumbLabels?.[i]} />
          ))
        }
      </SliderTrack>
    </Slider>
  )
}
